import { render, staticRenderFns } from "./SingleVideo.vue?vue&type=template&id=166b933d&scoped=true&"
import script from "./SingleVideo.vue?vue&type=script&lang=js&"
export * from "./SingleVideo.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=166b933d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166b933d",
  null
  
)

export default component.exports